import get from "lodash/get";
import Card from "@druva-apps/orion/lib/card";
import Col from "@druva-apps/orion/lib/col";
import LabelValue from "@druva-apps/orion/lib/labelValue";
import Loader from "@druva-apps/orion/lib/loader";
import Row from "@druva-apps/orion/lib/row";
import React from "react";
import clsx from "clsx";

import { IMetaDataCardProps } from "./types";
import styles from "./meta-data-card.module.scss";

const MetaDataCard: React.FC<IMetaDataCardProps> = ({
  metadata,
  data,
  cardProps,
  renderHeader,
  isLoading,
  rowClassName,
  loadingText,
}) => {
  const { fields, layout } = metadata;

  const getBody = () => (
    <>
      {renderHeader?.()}
      {layout.groups.map((group, index, groups) => {
        const { title, key, children = [], renderFooter } = group;
        return (
          <div key={key}>
            {title && <Card.Title title={title} className="oui-mb-2" />}
            {children.length > 0 ? (
              <Row
                className={clsx(styles.metaDataCard, {
                  "oui-mt-2": rowClassName,
                })}
              >
                {children.map((fieldName) => {
                  const fieldProps = fields[fieldName];
                  const {
                    colSpan,
                    colClassName,
                    valueGetter,
                    ...labelValueProps
                  } = fieldProps ?? {};
                  return (
                    <Col
                      sm={colSpan ?? "3"}
                      key={fieldName}
                      className={colClassName ?? "oui-mb-1"}
                    >
                      {fieldName && (
                        <LabelValue
                          {...labelValueProps}
                          value={
                            valueGetter?.(get(data, fieldName), data) ??
                            get(data, fieldName, "-")
                          }
                          type="summary"
                        />
                      )}
                    </Col>
                  );
                })}
              </Row>
            ) : null}
            {renderFooter?.()}
            {/* Add horizontal rule except for last group */}
            {index < groups.length - 1 && <hr />}
          </div>
        );
      })}
    </>
  );

  return (
    <Loader isLoading={isLoading} text={loadingText}>
      <Card {...cardProps} body={getBody} />
    </Loader>
  );
};

export default MetaDataCard;
